import coreAPIInstance from "./coreApiInstance";

export const subtitleAPIs = {
  getSubtitlesTemplates: ({ payload }) => coreAPIInstance.post(`/api/v1/subtitles/template.list`, payload),
  createSubtitlesTemplate: ({ payload }) => coreAPIInstance.post(`api/v1/subtitles/template.create`, payload),
  getSubtitlesTemplateById: ({ payload }) =>
    coreAPIInstance.get(`/api/v1/subtitles/template.get/${payload.templateId}`, payload),
  updateSubtitlesTemplate: ({ id, payload }) => coreAPIInstance.put(`/api/v1/subtitles/template.update/${id}`, payload),
  deleteSubtitlesTemplate: ({ id, payload }) =>
    coreAPIInstance.delete(`/api/v1/subtitles/template.delete/${id}`, payload),
  generateSubtitleTranscripts: ({ payload }) => coreAPIInstance.post(`/api/v1/subtitles/transcript.generate`, payload),
  burnSubtitles: ({ payload }) => coreAPIInstance.post(`/api/v1/subtitles/subtitle.generate`, payload),
  getVariantSubtitleTemplates: ({ id, payload }) =>
    coreAPIInstance.get(`/api/v1/subtitles/variant.template/${id}`, payload),
  validateSrtFile: ({ payload }) => coreAPIInstance.post(`/api/v1/subtitles/validate.srt`, payload),
  getSubtitleFonts: ({ payload }) => coreAPIInstance.post(`/api/v1/subtitles/font.list`, payload),
  subtitleFontSupported: ({ payload }) => coreAPIInstance.post(`/api/v1/subtitles/font.supported`, payload),
};
